module.exports = __webpack_public_path__ + "static/img/kong.f7f98b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kong.png
// module id = mAJy
// module chunks = 1